import React, { useState, useContext } from 'react';
import {
  Alert,
  Box,
  Button,
  Divider,
  TextField,
  Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  QuestionRatio,
  QuestionTypeV2,
  PartialBy,
  GTRatioPayload,
  GroundTruthRatio,
} from '../../redux/types';
import ColorContext from '../../context/ColorContext';
import GTResetButton from './GTResetButton';

type Props = {
  surveyId: number;
  sectionId: number;
  questionId: number;
  caseId: number;
  question: QuestionRatio;
  groundTruthId?: number;
  payload?: GTRatioPayload;
  gtGroupId: number|null;
  onSave: (gtData: PartialBy<GroundTruthRatio, 'id'>) => void;
  onCancel: () => void;
  onDelete: (dgtId: number) => void;
};

const getInitialRatioPayload = (): GTRatioPayload => {
  const pay: GTRatioPayload = {
    answer: [0, 0],
    score: 0,
  };
  return pay;
};

const GTRatioEditor: React.FC<Props> = ({
  surveyId,
  sectionId,
  questionId,
  caseId,
  question,
  groundTruthId,
  payload,
  gtGroupId,
  onSave,
  onCancel,
  onDelete,
}: Props) => {
  const color = useContext(ColorContext);
  const [payloadBuffer, setpayloadBuffer] = useState<GTRatioPayload>(
    payload || getInitialRatioPayload(),
  );

  const saveHandler = () => {
    if (!payloadBuffer) {
      return;
    }
    const newGTRecord: PartialBy<GroundTruthRatio, 'id'> = {
      id: groundTruthId,
      digitalSurveyId: surveyId,
      digitalSectionId: sectionId,
      digitalQuestionId: questionId,
      digitalCaseId: caseId,
      type: QuestionTypeV2.Ratio,
      payload: payloadBuffer,
      digitalGroundTruthGroupId: gtGroupId,
    };
    onSave(newGTRecord);
  };

  const cancelHandler = () => {
    onCancel();
  };

  const handleRatioChange1 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setpayloadBuffer({
      ...payloadBuffer,
      answer: [value, payloadBuffer.answer[1]],
    });
  };

  const handleRatioChange2 = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setpayloadBuffer({
      ...payloadBuffer,
      answer: [payloadBuffer.answer[0], value],
    });
  };

  const handleScoreChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    setpayloadBuffer({
      ...payloadBuffer,
      score: value,
    });
  };

  return (
    <Box>
      <Alert severity="info" sx={{ my: 2 }}>
        RTU or - will be considered with no score
      </Alert>
      <Box sx={{ mx: 2, my: 3 }}>
        <Typography color="GrayText">{question.text}</Typography>
        <Box display="flex" gap={1} alignItems="center">
          <TextField onChange={handleRatioChange1} value={payloadBuffer.answer[0]} type="number" size="small" sx={{ width: 80 }} />
          <p>:</p>
          <TextField onChange={handleRatioChange2} value={payloadBuffer.answer[1]} type="number" size="small" sx={{ width: 80 }} />
        </Box>
        <Box sx={{ my: 2 }}>
          <TextField onChange={handleScoreChange} value={payloadBuffer.score} size="small" label="Score" type="number" sx={{ width: 180 }} />
        </Box>
      </Box>
      <Divider />
      <Box display="flex" sx={{ mt: 1 }} justifyContent="flex-end" gap={1}>
        <Box flexGrow={1}>
          <GTResetButton groundTruthId={groundTruthId} onReset={onDelete} />
        </Box>
        <Button variant="contained" color={color} onClick={saveHandler}><FormattedMessage id="save" /></Button>
        <Button variant="contained" color="secondary" onClick={cancelHandler}><FormattedMessage id="genericCancel" /></Button>
      </Box>
    </Box>
  );
};

export default GTRatioEditor;
